import { EmailEntityId } from "@sp-crm/core";
import React from "react";
import {
    AdvancedSearchEntityType,
    ConversationFeedBasicsFragment,
    ConversationThreadType,
} from "../../generated/graphql";
import { EmailThreadComponentLegacy } from "./email-thread-component-legacy";
import { SmsMessageThread } from "./sms-message-thread";

export interface ConversationFeedLegacyProps {
    feed: ConversationFeedBasicsFragment;
    initialThreadId?: string;
    entityId?: EmailEntityId;
    entityType?: AdvancedSearchEntityType;
}

export const ConversationFeedLegacy: React.FC<ConversationFeedLegacyProps> = props => {
    const { feed, initialThreadId, entityId, entityType } = props;

    return (
        <div className="flex flex-col max-w-screen-lg">
            <div>
                <ul role="list" className="space-y-2 p-2">
                    {feed.threads.length === 0 ? (
                        <div className="text-center text-gray-500 py-8">
                            <em>No messages yet</em>
                        </div>
                    ) : (
                        feed.threads.map(t => {
                            if (t.type === ConversationThreadType.Sms) {
                                return (
                                    <SmsMessageThread
                                        key={t.id}
                                        thread={t}
                                        initialThreadId={initialThreadId}
                                    />
                                );
                            } else if (t.type === ConversationThreadType.EmailThread) {
                                return (
                                    <EmailThreadComponentLegacy
                                        key={t.id}
                                        thread={t}
                                        entityId={entityId}
                                        entityType={entityType}
                                    />
                                );
                            } else {
                                return null;
                            }
                        })
                    )}
                </ul>
            </div>
        </div>
    );
};
